import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';

// Context
import { AuthProvider } from './context/AuthContext';
import { StudentProvider } from './context/StudentContext';

// Components (keep critical components synchronous)
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AnnouncementBar from './components/AnnouncementBar';

// Lazy load all pages to reduce initial bundle size
const Home = lazy(() => import('./pages/Home'));
const AboutUs = lazy(() => import('./pages/AboutUs'));
const PrincipalMessage = lazy(() => import('./pages/PrincipalMessage'));
const Administration = lazy(() => import('./pages/Administration'));
const IQAC = lazy(() => import('./pages/IQAC'));
const AISHE = lazy(() => import('./pages/AISHE'));
const Academics = lazy(() => import('./pages/Academics'));
const Courses = lazy(() => import('./pages/Courses'));
const UPRTOUStudyCentre = lazy(() => import('./pages/UPRTOUStudyCentre'));
const SeminarWebinar = lazy(() => import('./pages/SeminarWebinar'));
const StudentsCorner = lazy(() => import('./pages/StudentsCorner'));
const Faculty = lazy(() => import('./pages/Faculty'));
const Gallery = lazy(() => import('./pages/Gallery'));
const StudentRegistration = lazy(() => import('./pages/StudentRegistration'));
const StudentList = lazy(() => import('./pages/StudentList'));
const StudentDetails = lazy(() => import('./pages/StudentDetails'));
const PaymentSummary = lazy(() => import('./pages/PaymentSummary'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const OAuthLogin = lazy(() => import('./components/OAuthLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const AdminGallery = lazy(() => import('./pages/AdminGallery'));
const DocumentViewer = lazy(() => import('./pages/DocumentViewer'));

// Loading component for Suspense fallback
const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center min-vh-100">
    <div className="text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 text-muted">Loading page...</p>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <StudentProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <div className="App">
            <AnnouncementBar />
            <Navbar />
            <main className="min-vh-100">
              <Suspense fallback={<LoadingSpinner />}>
                <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/principal-message" element={<PrincipalMessage />} />
                <Route path="/administration" element={<Administration />} />
                <Route path="/iqac" element={<IQAC />} />
                <Route path="/aishe" element={<AISHE />} />
                <Route path="/academics" element={<Academics />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/uprtou-study-centre" element={<UPRTOUStudyCentre />} />
                <Route path="/seminar-webinar" element={<SeminarWebinar />} />
                <Route path="/students-corner" element={<StudentsCorner />} />
                <Route path="/faculty" element={<Faculty />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/register" element={<StudentRegistration />} />
                <Route path="/students" element={<StudentList />} />
                <Route path="/student/:id" element={<StudentDetails />} />
                <Route path="/payment-summary/:id" element={<PaymentSummary />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/reset-password" element={<ResetPassword />} />
                <Route path="/admin/oauth" element={<OAuthLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/gallery" element={<AdminGallery />} />
                <Route path="/view-document" element={<DocumentViewer />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
            <ToastContainer position="top-right" autoClose={5000} />
          </div>
        </Router>
      </StudentProvider>
    </AuthProvider>
  );
}

export default App;
